import React from 'react';
import PropTypes from 'prop-types';

import { TagBody, StyledClose } from './styles';
import { bytesToSize } from '../helpers';

function FileTag({ name, size, remove }) {
	const onRemove = () => remove(name);
	return (
		<TagBody>
			<p>{`${name} (${bytesToSize(size)})`}</p>
			<StyledClose type="close" onClick={onRemove} />
		</TagBody>
	);
}

FileTag.propTypes = {
	name: PropTypes.string,
	size: PropTypes.number,
	remove: PropTypes.func
};

export default FileTag;
